'use client';

import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useCookieConsent } from 'app/root/[isEU]/_components/cookie-consent';
import { isEnvDev } from 'utils';

export function Affiliate({ isEU }: { isEU: boolean }): JSX.Element {
  useSetAffonsoRef();
  const { isAccepted } = useCookieConsent();
  if (isEnvDev || (isEU && !isAccepted)) {
    return <></>;
  }
  return <AffonsoScript />;
}

export function AffonsoScript() {
  return (
    <Script
      src="https://cdn.affonso.io/js/pixel.min.js"
      strategy="afterInteractive"
      data-affonso="cm8a19m1a00098b0f4ilciqcb"
      data-cookie_duration="30"
      async
    />
  );
}

function useSetAffonsoRef() {
  // Affonso doesn't support cross-origin tracking,
  // so we need to set the ref on the client side
  const searchParams = useSearchParams();
  const atp = searchParams.get('atp');
  const affonso = searchParams.get('affonso');
  const via = searchParams.get('via');
  const aff = searchParams.get('aff');
  const ref = searchParams.get('ref');
  React.useEffect(() => {
    if (atp) {
      localStorage.setItem('affonso_atp', atp);
    }
    if (affonso) {
      localStorage.setItem('affonso_affonso', affonso);
    }
    if (aff) {
      localStorage.setItem('affonso_aff', aff);
    }
    if (via) {
      localStorage.setItem('affonso_via', via);
    }
    if (ref) {
      localStorage.setItem('affonso_ref', ref);
    }
  }, [atp, affonso, via, aff, ref]);
}
